<app-header [ngClass]="{'header': true, 'nav-fixed': isFixed}" />
<div id="content" class="content">
  @if (isPlatformBrowser) {
    <router-outlet />
  }
</div>